// File corresponds to src\app\trueup\monthly-calculations\monthly-true-up-calculation.component.ts

import { OnInit, Component, ErrorHandler, Input, EventEmitter, Output, ViewChild } from '@angular/core';
import { SystemStartTimeService } from '../../system-start-time.service';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { PageEvent } from '@angular/material/paginator';
import { MatSnackBarConfig, MatSnackBar } from '@angular/material/snack-bar';
import { MatSort } from '@angular/material/sort';
import { PaginatedGetResult } from '../../core/models/paginated-get-result';
import { Column, CollectionsDetailBase, CollectionsColumnConstants, CollectionsListColumnDef } from './collections-list-column-def';
import { ExportCollectionsFilterRepresentation } from './collections-filter/collections-export-filter-representation';

import { CollectionsFilterProperties } from './collections-filter/collections-filter-properties';
import { ExportSelectRepresentation } from '../../inventory-management/inventory-filter/export-representations';
import { Subject } from 'rxjs';

import { FilterOperator } from '../../core/query-strings/query-string-builder';
import { ColumnCustomizerDialogComponent } from '../../inventory-management/inventory-table/column-customizer-dialog/column-customizer-dialog.component';
import { PaginationParameters } from '../../core/models/pagination-paramters';
import { CollectionsFilterRepresentation } from './collections-filter/collections-filter-representation-base';
import { CollectionsListDataSourceBase } from './collections-list-data-source';
import { CollectionsDetailJsonConverter } from './collections-filter/services/collections-detail-json-converter';
import { CollectionsDetailService } from './collections-filter/services/collections-service-base';
import { DateTimeUtility } from '../../inventory-management/meters/meter-true-up/models/month-name-dictionary';



@Component({
  selector: 'app-collections',
  templateUrl: './collections.component.html',
  styleUrls: ['./collections.component.css']
})
export class CollectionsComponent implements OnInit {

  constructor(private systemStartTimeService: SystemStartTimeService, private errorHandler: ErrorHandler,
    private dialog: MatDialog, private service: CollectionsDetailService, public snackBar: MatSnackBar) {
      this.dataSubject = new Subject<PaginatedGetResult<CollectionsDetailBase>>();
    this.initializePaginationProperties();
    }
    loading: boolean;
    allColumns: Array<Column> = new Array<Column>();
    defaultColumns: Array<Column> = new Array<Column>();
    displayedColumns: Array<string> = new Array<string>();

    filterRepresentation: CollectionsFilterRepresentation;

    exportFilterRepresentation: ExportCollectionsFilterRepresentation;

    dataSubject: Subject<PaginatedGetResult<CollectionsDetailBase>>;

    hideFilter = false;
    errorMessage: any;

    dataSource: CollectionsListDataSourceBase;

    pageEvent: PageEvent;
    pageProperties: CollectionsFilterProperties;
    orderByColumn: string;
    GUIDS = [];
    // years, quarters, reportingQuarters, months,
    systemStartDate: Date;
    filterTypes = {
      meterId: 'meterId',
      dateOfCollection: 'dateOfCollection',
      timeOfCollection: 'timeOfCollection',
      dateReceived: 'dateReceived',
      totalCollectionAmount: 'collectionAmount',
      collectionType: 'collectionType',
      denominationName: 'denominationName',
      zone: 'zone',
      area: 'area',
      blockId: 'blockId',
      parkingType: 'parkingType',
      collectionNumber: 'collectionNumber',
      numberOfCoins: 'numberOfCoins',
      purchaseCount: 'purchaseCount',
      collectionGUID: 'collectionGUID'
    };
    meterIdFilterOperatorDropDown = [FilterOperator.Equal, FilterOperator.Contains];
    // TODO: add more filter drop downs here
    operatorDropDown = [FilterOperator.Equal, FilterOperator.GreaterThan, FilterOperator.LessThan, FilterOperator.NotEqual,
      FilterOperator.GreaterThanOrEqual, FilterOperator.LessThanOrEqual, FilterOperator.Between];
    dateRangeDropDown = [ FilterOperator.Between, FilterOperator.GreaterThan, FilterOperator.LessThan, FilterOperator.GreaterThanOrEqual, FilterOperator.LessThanOrEqual];
    parkingTypeDropDown = ['Block', 'Lot'];
    collectionTypeDropDown = ['Card', 'Coin', 'External Payunit 0', 'Mobile Payment', 'Unknown'];

    // there is likely a mat angular equivalent to this. Sub this though.
    /* Java code to print these values for the time dropdown
    class Main {
      public static void main(String[]args){
        for(int i =1; i<10; i++){
          for(int j=0;j<60;j++){
            if(j<10)
                System.out.print("'0"+i+":0"+j+"', ");
              else
                System.out.print("'0"+i+":"+j+"', ");
            }
          }
        }
      }
        */
    timeDropDown= [ '12:00', '12:01', '12:02', '12:03', '12:04', '12:05', '12:06', '12:07', '12:08', '12:09', '12:10', '12:11', '12:12', '12:13', '12:14', '12:15', '12:16', '12:17', '12:18', '12:19', '12:20', '12:21', '12:22', '12:23', '12:24', '12:25', '12:26', '12:27', '12:28', '12:29', '12:30', '12:31', '12:32', '12:33', '12:34', '12:35', '12:36', '12:37', '12:38', '12:39', '12:40', '12:41', '12:42', '12:43', '12:44', '12:45', '12:46', '12:47', '12:48', '12:49', '12:50', '12:51', '12:52', '12:53', '12:54', '12:55', '12:56', '12:57', '12:58', '12:59', '01:00', '01:01', '01:02', '01:03', '01:04', '01:05', '01:06', '01:07', '01:08', '01:09', '01:10', '01:11', '01:12', '01:13', '01:14', '01:15', '01:16', '01:17', '01:18', '01:19', '01:20', '01:21', '01:22', '01:23', '01:24', '01:25', '01:26', '01:27', '01:28', '01:29', '01:30', '01:31', '01:32', '01:33', '01:34', '01:35', '01:36', '01:37', '01:38', '01:39', '01:40', '01:41', '01:42', '01:43', '01:44', '01:45', '01:46', '01:47', '01:48', '01:49', '01:50', '01:51', '01:52', '01:53', '01:54', '01:55', '01:56', '01:57', '01:58', '01:59', '02:00', '02:01', '02:02', '02:03', '02:04', '02:05', '02:06', '02:07', '02:08', '02:09', '02:10', '02:11', '02:12', '02:13', '02:14', '02:15', '02:16', '02:17', '02:18', '02:19', '02:20', '02:21', '02:22', '02:23', '02:24', '02:25', '02:26', '02:27', '02:28', '02:29', '02:30', '02:31', '02:32', '02:33', '02:34', '02:35', '02:36', '02:37', '02:38', '02:39', '02:40', '02:41', '02:42', '02:43', '02:44', '02:45', '02:46', '02:47', '02:48', '02:49', '02:50', '02:51', '02:52', '02:53', '02:54', '02:55', '02:56', '02:57', '02:58', '02:59', '03:00', '03:01', '03:02', '03:03', '03:04', '03:05', '03:06', '03:07', '03:08', '03:09', '03:10', '03:11', '03:12', '03:13', '03:14', '03:15', '03:16', '03:17', '03:18', '03:19', '03:20', '03:21', '03:22', '03:23', '03:24', '03:25', '03:26', '03:27', '03:28', '03:29', '03:30', '03:31', '03:32', '03:33', '03:34', '03:35', '03:36', '03:37', '03:38', '03:39', '03:40', '03:41', '03:42', '03:43', '03:44', '03:45', '03:46', '03:47', '03:48', '03:49', '03:50', '03:51', '03:52', '03:53', '03:54', '03:55', '03:56', '03:57', '03:58', '03:59', '04:00', '04:01', '04:02', '04:03', '04:04', '04:05', '04:06', '04:07', '04:08', '04:09', '04:10', '04:11', '04:12', '04:13', '04:14', '04:15', '04:16', '04:17', '04:18', '04:19', '04:20', '04:21', '04:22', '04:23', '04:24', '04:25', '04:26', '04:27', '04:28', '04:29', '04:30', '04:31', '04:32', '04:33', '04:34', '04:35', '04:36', '04:37', '04:38', '04:39', '04:40', '04:41', '04:42', '04:43', '04:44', '04:45', '04:46', '04:47', '04:48', '04:49', '04:50', '04:51', '04:52', '04:53', '04:54', '04:55', '04:56', '04:57', '04:58', '04:59', '05:00', '05:01', '05:02', '05:03', '05:04', '05:05', '05:06', '05:07', '05:08', '05:09', '05:10', '05:11', '05:12', '05:13', '05:14', '05:15', '05:16', '05:17', '05:18', '05:19', '05:20', '05:21', '05:22', '05:23', '05:24', '05:25', '05:26', '05:27', '05:28', '05:29', '05:30', '05:31', '05:32', '05:33', '05:34', '05:35', '05:36', '05:37', '05:38', '05:39', '05:40', '05:41', '05:42', '05:43', '05:44', '05:45', '05:46', '05:47', '05:48', '05:49', '05:50', '05:51', '05:52', '05:53', '05:54', '05:55', '05:56', '05:57', '05:58', '05:59', '06:00', '06:01', '06:02', '06:03', '06:04', '06:05', '06:06', '06:07', '06:08', '06:09', '06:10', '06:11', '06:12', '06:13', '06:14', '06:15', '06:16', '06:17', '06:18', '06:19', '06:20', '06:21', '06:22', '06:23', '06:24', '06:25', '06:26', '06:27', '06:28', '06:29', '06:30', '06:31', '06:32', '06:33', '06:34', '06:35', '06:36', '06:37', '06:38', '06:39', '06:40', '06:41', '06:42', '06:43', '06:44', '06:45', '06:46', '06:47', '06:48', '06:49', '06:50', '06:51', '06:52', '06:53', '06:54', '06:55', '06:56', '06:57', '06:58', '06:59', '07:00', '07:01', '07:02', '07:03', '07:04', '07:05', '07:06', '07:07', '07:08', '07:09', '07:10', '07:11', '07:12', '07:13', '07:14', '07:15', '07:16', '07:17', '07:18', '07:19', '07:20', '07:21', '07:22', '07:23', '07:24', '07:25', '07:26', '07:27', '07:28', '07:29', '07:30', '07:31', '07:32', '07:33', '07:34', '07:35', '07:36', '07:37', '07:38', '07:39', '07:40', '07:41', '07:42', '07:43', '07:44', '07:45', '07:46', '07:47', '07:48', '07:49', '07:50', '07:51', '07:52', '07:53', '07:54', '07:55', '07:56', '07:57', '07:58', '07:59', '08:00', '08:01', '08:02', '08:03', '08:04', '08:05', '08:06', '08:07', '08:08', '08:09', '08:10', '08:11', '08:12', '08:13', '08:14', '08:15', '08:16', '08:17', '08:18', '08:19', '08:20', '08:21', '08:22', '08:23', '08:24', '08:25', '08:26', '08:27', '08:28', '08:29', '08:30', '08:31', '08:32', '08:33', '08:34', '08:35', '08:36', '08:37', '08:38', '08:39', '08:40', '08:41', '08:42', '08:43', '08:44', '08:45', '08:46', '08:47', '08:48', '08:49', '08:50', '08:51', '08:52', '08:53', '08:54', '08:55', '08:56', '08:57', '08:58', '08:59', '09:00', '09:01', '09:02', '09:03', '09:04', '09:05', '09:06', '09:07', '09:08', '09:09', '09:10', '09:11', '09:12', '09:13', '09:14', '09:15', '09:16', '09:17', '09:18', '09:19', '09:20', '09:21', '09:22', '09:23', '09:24', '09:25', '09:26', '09:27', '09:28', '09:29', '09:30', '09:31', '09:32', '09:33', '09:34', '09:35', '09:36', '09:37', '09:38', '09:39', '09:40', '09:41', '09:42', '09:43', '09:44', '09:45', '09:46', '09:47', '09:48', '09:49', '09:50', '09:51', '09:52', '09:53', '09:54', '09:55', '09:56', '09:57', '09:58', '09:59', '10:00', '10:01', '10:02', '10:03', '10:04', '10:05', '10:06', '10:07', '10:08', '10:09', '10:10', '10:11', '10:12', '10:13', '10:14', '10:15', '10:16', '10:17', '10:18', '10:19', '10:20', '10:21', '10:22', '10:23', '10:24', '10:25', '10:26', '10:27', '10:28', '10:29', '10:30', '10:31', '10:32', '10:33', '10:34', '10:35', '10:36', '10:37', '10:38', '10:39', '10:40', '10:41', '10:42', '10:43', '10:44', '10:45', '10:46', '10:47', '10:48', '10:49', '10:50', '10:51', '10:52', '10:53', '10:54', '10:55', '10:56', '10:57', '10:58', '10:59', '11:00', '11:01', '11:02', '11:03', '11:04', '11:05', '11:06', '11:07', '11:08', '11:09', '11:10', '11:11', '11:12', '11:13', '11:14', '11:15', '11:16', '11:17', '11:18', '11:19', '11:20', '11:21', '11:22', '11:23', '11:24', '11:25', '11:26', '11:27', '11:28', '11:29', '11:30', '11:31', '11:32', '11:33', '11:34', '11:35', '11:36', '11:37', '11:38', '11:39', '11:40', '11:41', '11:42', '11:43', '11:44', '11:45', '11:46', '11:47', '11:48', '11:49', '11:50', '11:51', '11:52', '11:53', '11:54', '11:55', '11:56', '11:57', '11:58', '11:59'];

    // timeHourDropDown = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23];
    // timeMinuteDropDown= ['00', '01', '02' , '03', '04', '05', '06', '07', '08', '09', 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60];
    timeSecondDropDown= ['00', '01', '02' , '03', '04', '05', '06', '07', '08', '09', 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60];
    ampmDropDown = ['AM', 'PM'];

    totalItems: number;
    itemsSubject: Subject< Array<CollectionsDetailBase>>;
    dialogRef: MatDialogRef<ColumnCustomizerDialogComponent>;

    @ViewChild(MatSort, {static: true}) sort: MatSort;

    private initializePaginationProperties() {
      this.pageProperties = new CollectionsFilterProperties();
      this.pageProperties.paginationParameters = new PaginationParameters();
      this.filterRepresentation = new CollectionsFilterRepresentation();

      this.pageProperties.paginationParameters.orderByColumn = this.orderByColumn;
      this.pageProperties.paginationParameters.pageSize = 25;
      this.pageProperties.paginationParameters.pageIndex = 0;
      this.pageProperties.paginationParameters.isAscending = true;
      this.pageProperties.paginationParameters.totalItemCount = 0;

      this.pageEvent = new PageEvent();
      this.pageEvent.length = this.pageProperties.paginationParameters.pageIndex;
      this.pageEvent.pageIndex = this.pageProperties.paginationParameters.pageIndex;
      this.pageEvent.pageSize = this.pageProperties.paginationParameters.pageSize;

      this.itemsSubject = new Subject<Array<CollectionsDetailBase>>();
    }

   handleFilterUpdated(filterProperties: CollectionsFilterProperties) {
    this.loading = true;
    this.refreshDataSource(filterProperties.paginationParameters, filterProperties.filterRepresentation);
}

refreshDataSource(paginationParameters: PaginationParameters, filterRepresentation: CollectionsFilterRepresentation) {
  const skip  = paginationParameters.pageIndex * paginationParameters.pageSize;
  const take = paginationParameters.pageSize;
  const emptyResult = new PaginatedGetResult<CollectionsDetailBase>();
  this.dataSubject.next(emptyResult);

// defaults when there is nothing set, prevents failure on large data sets
if (!paginationParameters.orderByColumn
|| paginationParameters.orderByColumn === '') {
paginationParameters.orderByColumn = CollectionsListColumnDef.dateOfCollection.constant; // TODO CHECK TOO
paginationParameters.isAscending = true;
}
// otherwise be sure it is empty
filterRepresentation.GUIDS = undefined;


const result = this.service.getAllItems(
   paginationParameters.orderByColumn, paginationParameters.isAscending,
   skip, take, filterRepresentation)
.subscribe(paginationResult => {
   this.dataSubject.next(paginationResult);
   this.loading = false;
   },
   error => {
       this.loading = false;
       console.log(error);
       if (error.status = 500){
        this.snackBar.open('Error:'.concat(error._body), 'X', <MatSnackBarConfig>{
          duration: 5000,
        });
       }


   });


}
    ngOnInit(): void {
      this.exportFilterRepresentation = new ExportCollectionsFilterRepresentation();

      this.initializeSystemStartYear();
      // if (!this.hideFilter) {
      //   this.initializeFilters();
      // }

      if (!this.service.collectionFilter) {
        this.service.collectionFilter = new CollectionsFilterRepresentation();
        this.filterRepresentation = this.service.collectionFilter
      } else {
        this.filterRepresentation = this.service.collectionFilter;
      }
      
      this.filter(true);
      console.log('service filter AFTER:', this.service.collectionFilter);

       var dataSourceObservable = this.dataSubject.asObservable();

       dataSourceObservable.subscribe(result => {
         this.totalItems = result.totalItems;
         this.pageProperties.paginationParameters.pageIndex = 0;
         this.itemsSubject.next(result.items);
      });
     // TODO DATA SOURCE COME HERE PROBLEM

      this.displayedColumns = new Array<string>();
        this.allColumns = CollectionsColumnConstants.AllMeterColumns;
        this.defaultColumns = CollectionsColumnConstants.AllMeterColumns;
        this.defaultColumns.forEach(column => {
          this.displayedColumns.push(column.constant);
        });

      this.dataSource = new CollectionsListDataSourceBase(this.itemsSubject.asObservable());
    }

    clear(filterType): void {
      switch (filterType) {
        case this.filterTypes.meterId:
          this.filterRepresentation.MeterId = null;
          break;
        case this.filterTypes.dateOfCollection:
          this.filterRepresentation.DateOfCollection = this.filterRepresentation.MarchFirst;
          this.filter(true);
          break;
        case this.filterTypes.timeOfCollection:
          this.filterRepresentation.TimeOfCollection = null;
          break;
        case this.filterTypes.dateReceived:
          this.filterRepresentation.DateReceived = null;
          this.filterRepresentation.DateReceivedEnd = null;
          break;
        case this.filterTypes.collectionType:
          this.filterRepresentation.CollectionType = null;
          break;
        case this.filterTypes.totalCollectionAmount:
          this.filterRepresentation.CollectionAmount = null;
          break;
        case this.filterTypes.denominationName:
          this.filterRepresentation.DenominationName = null;
          break;
        case this.filterTypes.zone:
          this.filterRepresentation.Zone = null;
          break;
        case this.filterTypes.area:
          this.filterRepresentation.Area = null;
          break;
        case this.filterTypes.blockId:
          this.filterRepresentation.BlockId = null;
          break;
        case this.filterTypes.parkingType:
          this.filterRepresentation.ParkingType = null;
          break;
        case this.filterTypes.collectionNumber:
          this.filterRepresentation.CollectionNumber = null;
          break;
        case this.filterTypes.numberOfCoins:
          this.filterRepresentation.NumberOfCoins = null;
          break;
        case this.filterTypes.purchaseCount:
          this.filterRepresentation.PurchaseCount = null;
          break;
        case this.filterTypes.collectionGUID:
          this.filterRepresentation.CollectionGUID = null;
      }
      this.filter(true);
    }

  exportCollectionsReport(ect: ExportCollectionsFilterRepresentation) {
    const orderByColumn = ect.CollectionsFilterProperties.paginationParameters.orderByColumn;
    const isAscending = ect.CollectionsFilterProperties.paginationParameters.isAscending;
    this.snackBar.open('Downloading Report', '', <MatSnackBarConfig>{
        duration: 2000
    });
    // otherwise be sure it is empty
    this.service.requestCollectionsReport(orderByColumn, isAscending, ect).subscribe(result => {
        this.service.downloadReport(result.result);
    },
    error => {
        this.errorHandler.handleError(error);
    });

  }

  sortChanged(event) {
    if ((this.sort.direction !== ''
    && this.pageProperties.paginationParameters.isAscending !== (this.sort.direction === 'asc'))
    || (this.sort.active !== '' && this.pageProperties.paginationParameters.orderByColumn !== this.sort.active)) {
      this.pageProperties.paginationParameters.isAscending = (this.sort.direction === 'asc') || (this.sort.direction === '');
      this.pageProperties.paginationParameters.orderByColumn = this.sort.active;
    }
    this.filter(true);
  }

  initializeFilters() {
    this.clearFilters();
    // this.ClearDateOfCollection();
      }

  clearFilters() {
    this.filterRepresentation = new CollectionsFilterRepresentation();

    // reset sorting too
    this.pageProperties.paginationParameters.orderByColumn = null;
    this.pageProperties.paginationParameters.isAscending = true;
    this.filterRepresentation.DateOfCollection = new Date(this.filterRepresentation.MarchFirst);
    this.filter(true);
  }

  filter(newFilterApplied: boolean= false) {
    this.pageProperties.filterRepresentation = this.filterRepresentation;
    if (newFilterApplied) {
      this.pageEvent.pageIndex = 0;
    }
    this.handleFilterUpdated(this.pageProperties);
  }

  filterButtonClicked() {
    this.filter(true);
  }

  emitExportFilterRepresentation() {
    this.exportFilterRepresentation.CollectionsFilterRepresentation = this.filterRepresentation;
    this.exportFilterRepresentation.CollectionsFilterProperties = this.pageProperties;

    this.exportCollectionsReport(this.exportFilterRepresentation);
  }

  refreshDataSourceForPageEvent(event: PageEvent) {
    this.pageProperties.paginationParameters.pageIndex = event.pageIndex;
    this.pageProperties.paginationParameters.pageSize = event.pageSize;
    this.pageEvent = event;

    this.filter();
  }

  onMeterIdChange(meterId) {
    this.filterRepresentation.MeterId = meterId;
  }
  onDateOfCollectionChange(dateOfCollection) {
    this.filterRepresentation.DateOfCollection = dateOfCollection;
  }
  onDateOfCollectionEndChange(dateOfCollectionEnd) {
    this.filterRepresentation.DateOfCollectionEnd = dateOfCollectionEnd;
  }

  // timeParser is an algorithm that parses time based on how we read it in
  // we read in: 'hours:minutes' (in hh:mm format) , AM/PM, & 'seconds' (in ss format) separately.
  // need to concatenate these fields into a single 24 hour time string that looks like this: hh:mm:ss
 // tslint:disable-next-line: member-ordering
 static timeParser(hourMin, ampm, seconds){
    var finaltime = undefined;
    var fields = hourMin.split(':', 2); // split into [hours,min] -> fields[0,1]

    if ( ampm === 'AM') { // we have less work to do
      // 12am = 00: need to check.
      if (fields[0] === '12'){
        finaltime = '00'.concat(':', fields[1], ':', seconds );
      }
      else{
        finaltime = hourMin.concat(':', seconds);
      }
     }
    else if (ampm === 'PM') {
      //  12pm == 12: need to check
      if (fields[0] === '12'){
        finaltime = hourMin.concat(':', seconds);
      }
      else{
        fields[0] = '' + ( +fields[0] + 12); // if pm, add 12 to hours
        finaltime = fields[0].concat(':', fields[1], ':', seconds);
      }
    }
    return finaltime;
  }


  onTimeOfCollectionChange(timeOfCollectionHM, ampm, timeOfCollectionSeconds) {
    if (timeOfCollectionHM !== undefined) {
      this.filterRepresentation.TimeOfCollection = CollectionsComponent.timeParser(timeOfCollectionHM, ampm, timeOfCollectionSeconds);
    }
}
  onTimeOfCollectionEndChange(timeOfCollectionHMEnd, ampmEnd, timeOfCollectionSecondsEnd) {
    if (timeOfCollectionHMEnd !== undefined) {
    this.filterRepresentation.TimeOfCollectionEnd = CollectionsComponent.timeParser(timeOfCollectionHMEnd, ampmEnd, timeOfCollectionSecondsEnd);
    }
  }

  onDateReceivedChange(dateReceived) {
    this.filterRepresentation.DateReceived = dateReceived;
  }
  onDateReceivedEndChange(dateReceivedEnd) {
    this.filterRepresentation.DateReceivedEnd = dateReceivedEnd;
  }

  onCollectionTypeChange(collectionType) {
    this.filterRepresentation.CollectionType = collectionType;
  }
  onCollectionAmountChange(collectionAmount) {
    this.filterRepresentation.CollectionAmount = collectionAmount;
  }
  onDenominationNameChange(denominationName) {
    this.filterRepresentation.DenominationName = denominationName;
  }
  onZoneChange(zone) {
    this.filterRepresentation.Zone = zone;
  }
  onAreaChange(Area) {
    this.filterRepresentation.Area = Area;
  }
  onBlockIdChange(BlockId) {
    this.filterRepresentation.BlockId = BlockId;
  }
  onParkingTypeChange(ParkingType) {
    this.filterRepresentation.ParkingType = ParkingType;
  }
  onCollectionNumberChange(CollectionNumber) {
    this.filterRepresentation.CollectionNumber = CollectionNumber;
  }
  onNumberOfCoinsChange(NumberOfCoins) {
    this.filterRepresentation.NumberOfCoins = NumberOfCoins;
  }
  onPurchaseCountChange(PurchaseCount) {
    this.filterRepresentation.PurchaseCount = PurchaseCount;
  }
  onCollectionGUIDChange(CollectionGUID) {
    this.filterRepresentation.CollectionGUID = CollectionGUID;
  }









  // TODO may or may not need this, from true up calculations stuff
  initializeSystemStartYear() {
    this.systemStartTimeService.getInitialSystemStartTime().subscribe(
     result => {
       this.systemStartDate = result;
     },
     error => {
       console.log('error in initialize System Start Year');
       this.errorHandler.handleError(error);
     }
    );
  }

}




